export default "__VITE_ASSET__BPpG9jhd__"